var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.voteEnabled
    ? _c(
        "div",
        { staticClass: "vote" },
        [
          _c(
            "BaseShape",
            {
              class: ["vote__svg", _vm.voted ? "vote__svg--animate" : ""],
              attrs: { viewBox: "0 0 18 17" }
            },
            [_c("HeartIcon")],
            1
          ),
          _c("p", { staticClass: "vote__text" }, [
            _vm._v("Подобається " + _vm._s(_vm.likes))
          ]),
          _c(
            "button",
            {
              staticClass: "vote__btn",
              class: ["btn", _vm.disabled ? "btn--disabled" : ""],
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.like.apply(null, arguments)
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.voted ? _vm.voteObj.unvote : _vm.voteObj.vote) +
                  "\n  "
              )
            ]
          ),
          _c(
            "BaseModal",
            {
              attrs: { opened: _vm.isOpened, position: "center" },
              on: {
                close: function($event) {
                  _vm.isOpened = false
                }
              }
            },
            [
              _c("template", { slot: "body" }, [
                _c("span", { staticClass: "vote__error" }, [
                  _vm._v("\n        " + _vm._s(_vm.textErrorModal) + "\n      ")
                ])
              ])
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bc2f69b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bc2f69b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/VotingBlock.vue
// module id = +H8T
// module chunks = 0 1 2 3 5 6